// src/features/cart/api/increaseQuantity.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const increaseQuantity = (productId) => {
  return axios.patch(`/cart/increase/${productId}`);
};

export const useIncreaseQuantity = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: increaseQuantity,
    onSuccess: () => {
      queryClient.invalidateQueries('cart');
      addNotification({
        type: 'success',
        title: 'Quantity increased',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Update failed',
        message: 'Could not increase item quantity. Please try again.',
      });
    },
    ...config,
  });
};
